/**
 * Email normalisation + validation shared by the browser (instant form
 * feedback) and Convex (the authoritative server-side check). Pure, no deps.
 *
 * Deliberately pragmatic rather than RFC 5322 complete: one `@`, a non-empty
 * local part without whitespace, a dotted domain with a 2+ letter TLD, and the
 * RFC 5321 length limits. That rejects typos and junk while accepting every
 * address a real person types.
 */

/** RFC 5321: 254 characters for the full path, 64 for the local part. */
export const MAX_EMAIL_LENGTH = 254
const MAX_LOCAL_LENGTH = 64

const EMAIL_PATTERN =
  /^[^\s@"(),:;<>[\\\]]+@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/u

/** Trim + lowercase. Every stored or compared email goes through this. */
export function normalizeEmail(raw: string): string {
  return raw.trim().toLowerCase()
}

/** Whether an (already normalised or raw) email is plausibly deliverable. */
export function isValidEmail(raw: string): boolean {
  const email = normalizeEmail(raw)
  if (email.length === 0 || email.length > MAX_EMAIL_LENGTH) return false
  const at = email.lastIndexOf('@')
  if (at < 1 || at > MAX_LOCAL_LENGTH) return false
  const local = email.slice(0, at)
  if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) {
    return false
  }
  return EMAIL_PATTERN.test(email)
}
